import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock, renderList as _renderList } from "vue"

const _hoisted_1 = ["id", "onClick"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { CodeType } from '@/gql/graphql';
import {
  BAlert,
  BBadge,
  BButton,
  BButtonGroup,
  BCard,
  BTable,
  BTooltip,
} from 'bootstrap-vue-next';
import { ORGANIZATION_USER_ROLES } from '@/constants';
import { openRouterLink } from '@/utils/router-utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'CodeList',
  props: {
    codes: {},
    loading: { type: Boolean }
  },
  setup(__props: any) {

const router = useRouter();

// --- Component properties ---
const props = __props;

const noCodes = computed(() => {
  return props.codes.length === 0;
});

// --- Code Table Fields ---
const codeTableFields = [
  {
    key: 'code',
    label: 'Code',
    sortable: true,
    tdClass: 'align-middle',
  },
  {
    key: 'items',
    label: 'Associated Items',
    sortable: true,
    tdClass: 'align-middle',
  },
  {
    key: 'organization',
    label: 'Organization',
    sortable: true,
    tdClass: 'align-middle',
  },
  {
    key: 'orderRef',
    label: 'Order',
    sortable: true,
    tdClass: 'align-middle',
  },
  {
    key: 'actions',
    label: '',
    sortable: false,
    tdClass: 'align-middle text-end min-width',
  },
];

function getOrganizationDetails(code: CodeType) {
  // check organization association
  if (!code.organization) {
    return '-';
  }
  // identify organization owner
  const owner = code.organization.usersAssociated?.find(
    (assoc) =>
      assoc &&
      assoc.userRole === ORGANIZATION_USER_ROLES.OWNER &&
      assoc.removedAt === null
  );
  // return org name + owner email
  return code.organization.name + (owner ? ` (${owner.user?.email})` : '');
}

// --- Copy Code Functionality ---
const copied = ref<string | null>(null);
function copyCode(code: string) {
  navigator.clipboard.writeText(code).then(() => {
    copied.value = code;
    setTimeout(() => (copied.value = null), 2_000);
  });
}

// --- Code Detail Request ---
function handleCodeDetailRequest(
  code: CodeType,
  _index: number,
  evt: MouseEvent
) {
  // Any element that lives inside the “no-row-click” cell?  Abort.
  if (
    evt.target instanceof HTMLElement &&
    evt.target.closest('.no-row-click')
  ) {
    return;
  }
  // check if code is available
  if (!code || !code.code) {
    console.error('Code detail request failed, code is missing');
    return;
  }
  // identify the target
  openRouterLink(
    {
      name: 'CodeDetail',
      params: { code: code.code },
    },
    router,
    evt
  );
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(BAlert), {
      modelValue: noCodes.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((noCodes).value = $event)),
      variant: "secondary"
    }, {
      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createTextVNode("No codes associated with kits or coupons currently available.", -1)
      ]))]),
      _: 1
    }, 8, ["modelValue"]),
    (props.codes.length > 0)
      ? (_openBlock(), _createBlock(_unref(BCard), {
          key: 0,
          class: "my-3"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BTable), {
              items: props.codes,
              busy: __props.loading,
              fields: codeTableFields,
              small: "",
              striped: "",
              responsive: "",
              hover: "",
              class: "browser-table",
              onRowClicked: handleCodeDetailRequest
            }, {
              "cell(code)": _withCtx((data) => [
                _createElementVNode("span", {
                  id: `code-target-${data.value}`,
                  class: "no-row-click",
                  onClick: _withModifiers(($event: any) => (copyCode(data.value)), ["stop"])
                }, [
                  _createElementVNode("strong", null, _toDisplayString(data.value), 1)
                ], 8, _hoisted_1),
                _createVNode(_unref(BTooltip), {
                  target: `code-target-${data.value}`
                }, {
                  default: _withCtx(() => [
                    (copied.value === data.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                          _createTextVNode(" Code " + _toDisplayString(data.value) + " copied to clipboard ", 1),
                          _createVNode(_component_font_awesome_icon, { icon: ['fas', 'check'] })
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_3, [
                          _cache[2] || (_cache[2] = _createTextVNode(" Click to copy code to clipboard ", -1)),
                          _createVNode(_component_font_awesome_icon, { icon: ['fas', 'copy'] })
                        ]))
                  ]),
                  _: 2
                }, 1032, ["target"])
              ]),
              "cell(items)": _withCtx((data) => [
                (data.item.kit)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_unref(BBadge), {
                        class: "mx-1",
                        variant: "primary",
                        id: `kit-target-${data.item.kit.id}`
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, { icon: ['fas', 'cube'] }),
                          _createTextVNode(" " + _toDisplayString(data.item.kit.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["id"]),
                      _createVNode(_unref(BTooltip), {
                        target: `kit-target-${data.item.kit.id}`
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(data.item.kit.description) + " ", 1),
                          _cache[3] || (_cache[3] = _createElementVNode("hr", null, null, -1)),
                          _cache[4] || (_cache[4] = _createElementVNode("strong", null, "Version:", -1)),
                          _createTextVNode(" " + _toDisplayString(data.item.kit.version ? data.item.kit.version : 'not specified'), 1),
                          _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                          _cache[6] || (_cache[6] = _createElementVNode("strong", null, "Barcodes whitelist:", -1)),
                          _createTextVNode(" " + _toDisplayString(data.item.kit.barcode), 1),
                          _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                          _cache[8] || (_cache[8] = _createElementVNode("strong", null, "UMI length:", -1)),
                          _createTextVNode(" " + _toDisplayString(data.item.kit.umiLength), 1),
                          _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                          _cache[10] || (_cache[10] = _createElementVNode("strong", null, "Samples:", -1)),
                          _createTextVNode(" " + _toDisplayString(data.item.kit.sampleCount), 1)
                        ]),
                        _: 2
                      }, 1032, ["target"])
                    ], 64))
                  : _createCommentVNode("", true),
                (data.item.license)
                  ? (_openBlock(), _createBlock(_unref(BBadge), {
                      key: 1,
                      class: "mx-1",
                      variant: "danger"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'certificate'] }),
                        _createTextVNode(" " + _toDisplayString(data.item.license.name), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.item.coupons, (coupon) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: coupon.id
                  }, [
                    _createVNode(_unref(BBadge), {
                      id: `coupon-target-${coupon.id}`,
                      variant: 
                coupon.couponType.includes('compute') ? 'warning' : 'success'
              ,
                      class: "mx-1"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'ticket'] }),
                        _createTextVNode(" " + _toDisplayString(coupon.couponType), 1)
                      ]),
                      _: 2
                    }, 1032, ["id", "variant"]),
                    _createVNode(_unref(BTooltip), {
                      target: `coupon-target-${coupon.id}`
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(coupon.unitsRemaining) + " of " + _toDisplayString(coupon.unitsTotal) + " " + _toDisplayString(coupon.units) + " remaining ", 1)
                      ]),
                      _: 2
                    }, 1032, ["target"])
                  ], 64))
                }), 128))
              ]),
              "cell(organization)": _withCtx((data) => [
                _createTextVNode(_toDisplayString(getOrganizationDetails(data.item)), 1)
              ]),
              "cell(actions)": _withCtx((data) => [
                _createVNode(_unref(BButtonGroup), null, {
                  default: _withCtx(() => [
                    (data.item.comment)
                      ? (_openBlock(), _createBlock(_unref(BButton), {
                          key: 0,
                          variant: "outline-secondary",
                          class: "btn-sm"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, {
                              icon: ['fa', 'comment'],
                              id: `comment-target-${data.item.id}`
                            }, null, 8, ["id"])
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true),
                    _createVNode(_unref(BButton), {
                      variant: "outline-secondary",
                      class: "btn-sm",
                      onClick: ($event: any) => (handleCodeDetailRequest(data.item, data.item.id, $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: ['fa', 'eye'] })
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 2
                }, 1024),
                (data.item.comment)
                  ? (_openBlock(), _createBlock(_unref(BTooltip), {
                      key: 0,
                      target: `comment-target-${data.item.id}`,
                      triggers: "hover"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(data.item.comment), 1)
                      ]),
                      _: 2
                    }, 1032, ["target"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["items", "busy"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})